// extracted by extract-css-chunks-webpack-plugin
module.exports = {"container":"_31c8La"};